import React, {ReactNode} from 'react';
import Main from './Main';
import Page, {PageType} from '@episerver/spa-core/Page';
import MineEquipmentPageData from '../../../Models/Content/MineEquipmentPageData';

export default class MineEquipmentPage extends Page<MineEquipmentPageData> {
  public render(): ReactNode {
    return <Main context={this.getContext()} iContent={this.props.data} />;
  }
}
